import { makeAutoObservable } from 'mobx';

export enum AsyncLoadableStatus {
  initial,
  loading,
  error,
  ready,
}

export class AsyncLoadable<T> {
  data: T;
  status = AsyncLoadableStatus.initial;
  error = '';

  constructor(initialValue: T) {
    this.data = initialValue;
    makeAutoObservable(this);
  }

  *load(loadingFunc: () => Promise<T>) {
    this.status = AsyncLoadableStatus.loading;
    try {
      this.data = yield loadingFunc();
      this.status = AsyncLoadableStatus.ready;
      this.error = '';
    } catch (error: any) {
      this.status = AsyncLoadableStatus.error;
      this.error = error.message;
    }
  }

  get isReady() {
    return this.status === AsyncLoadableStatus.ready;
  }

  get isError() {
    return this.status === AsyncLoadableStatus.error;
  }

  get isLoading() {
    return this.status === AsyncLoadableStatus.loading;
  }
}
